import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createSelector, createStructuredSelector } from 'reselect';
import { setGiveawayLandingVariantColor, setGiveawayLandingVariantSize, openGiveawayProductImage } from '../../../redux/giveaway-landing/giveaway-landing.actions';
import { hasGiveawayLandingProductSizesSelector, giveawayLandingProductImageSelector, isOneProductSelector, giveawayLandingProductSizesSettingsSelector, selectedColorsSelector, isGiveawayLandingProductSelectedSizeSelector } from '../../../redux/giveaway-landing/giveaway-landing.selectors';
import { GiveawayProductCardComponent } from './giveaway-product-card';
const shouldShowSizeSelectionSelector = createSelector(giveawayLandingProductSizesSettingsSelector, hasGiveawayLandingProductSizesSelector, isOneProductSelector, (sizeSettings, hasSizeToChoice, isOneProduct) => {
  return sizeSettings && hasSizeToChoice && isOneProduct;
});
const mapStateToProps = createStructuredSelector({
  size: isGiveawayLandingProductSelectedSizeSelector,
  selectedColors: selectedColorsSelector,
  sizeSettings: giveawayLandingProductSizesSettingsSelector,
  image: giveawayLandingProductImageSelector,
  isOneProduct: isOneProductSelector,
  shouldShowSizeSelection: shouldShowSizeSelectionSelector
});
const mapDispatchToProps = dispatch => bindActionCreators({
  setProductColor: setGiveawayLandingVariantColor,
  setProductSize: setGiveawayLandingVariantSize,
  openImage: openGiveawayProductImage
}, dispatch);
export const GiveawayProductCard = connect(mapStateToProps, mapDispatchToProps)(GiveawayProductCardComponent);